/* unplugin-vue-components disabled */import script from "./TierDefaultPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./TierDefaultPrice.vue?vue&type=script&lang=ts&setup=true"

import "./TierDefaultPrice.vue?vue&type=style&index=0&id=140f3405&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140f3405"]])

export default __exports__